import "../../sass/pages/trivia.scss";

import * as AOS from "aos";
import {Question} from "./questions"

import 'aos/dist/aos.css';

// window.drupalSettings.user.uid <= 0 && location.replace('/registro?param=trivia')
window.drupalSettings.user.uid <= 0 && location.replace('/home')

window.addEventListener("load", () => {
  validateAttempts()
  AOS.init({
    once: true,
  });
});


const url = `${window.origin}/game/auth-user`

const validateAttempts = async () => {
  const response = await fetch(url)
  const data = await response.json()
  
  !data && location.replace('/registro?param=trivia')
  data.message === 'USER_NOT_AUTHENTICATED' && location.replace('/registro?param=trivia')

  data.message === 'USER_AUTHENTICATED' &&
    data.triviaCompleted ? showAttemptsModal() : Question(true)
    // data.triviaCompleted ? location.href = '/intentos-agotados' : Question(true)
}


function showAttemptsModal(){
  const modal = document.querySelector('.modalTrivia') as HTMLElement
  modal && modal.classList.remove("is-close");

  // const btnTrivia = document.querySelector('#welcomeTrivia .welcome-trivia--main .btn_st') as HTMLElement
  // btnTrivia && btnTrivia.classList.add("hidden")
  
}